<template>
  <v-dialog v-model="dialog" scrollable max-width="300px">
    <template v-slot:activator="activator">
      <slot v-bind:activator="activator"></slot>
    </template>
    <v-card>
      <v-card-title>{{ title }}</v-card-title>
      <v-divider></v-divider>
      <v-card-text style="max-height: 400px">
        <v-list dense>
          <template v-for="(userId, index) in userIds">
            <v-list-item :key="userId">
              <v-list-item-avatar size="30">
                <v-img :src="userPic(userId)"></v-img>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title v-text="userName(userId)"></v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-divider v-if="index < userIds.length - 1" :key="`${userId}_div`"></v-divider>
          </template>
        </v-list>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="dialog = false"> Close </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: ["userIds", "title"],
  data() {
    return {
      dialog: false,
    };
  },
  methods: {
    userPic(userId) {
      return (
        this.$store.getters.getImageUrlById(userId) || require("@/assets/profile_pic_empty.png")
      );
    },
    userName(userId) {
      return this.$store.getters.getUserById(userId).name;
    },
  },
};
</script>
